import React from 'react'

import { string } from 'prop-types'

import useUseCaseTranslate from 'Pods/LazyLoaded/UseCaseAreaSidebar/hooks/useUseCaseTranslate'

function UseCaseUserInfo({ username, avatarUrl = null }) {
  const { t } = useUseCaseTranslate()

  return (
      <div className="use-case-info__item">
      <span className="use-case-info__item-title cgt-legacy-text-caption">{t('info.createdBy')}</span>
      <div className="use-case-info__item-value">
        {avatarUrl ? (
          <div className="use-case-info__item-avatar">
            <img
              src={avatarUrl}
              alt={username}
              className="use-case-info__item-avatar-img"
            />
          </div>
        ) : null}

        <a
          href={`/designers/${username}`}
          target="_blank"
          rel="noopener noreferrer"
          className="use-case-info__item-username">
          {username}
        </a>
      </div>
    </div>
  )
}

UseCaseUserInfo.propTypes = {
  username: string.isRequired,
  avatarUrl: string,
}

export default UseCaseUserInfo
